var _desc, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exitIconTitle"
  }, "Exit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "exitIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "exitIconDesc"
  }, "Icon of doors with an arrow pointing outside of them")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15l3-3-3-3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12H20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M21 12h-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4v16H4V4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.b5ac1c83c168a50eb03d1e24e537eede.svg";
export { ForwardRef as ReactComponent };